<flx-modal
  [dismissible]="true"
  (dismiss)="close()"
  class="flx-ds"
  data-testId="information-dialog"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    {{ title }}
  </div>
  <div
    [innerHTML]="subtitle"
    class="flx-modal-subtitle"
    flxModalHeaderSubtitle
  ></div>

  <div class="flx-modal-body">
    <div [innerHTML]="message"></div>
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="close()"
        class="flx-ds primary"
        data-testId="information-modal-close-button"
        flxButton
      >
        Close
      </button>
    </div>
  </div>
</flx-modal>
